import { useState, useEffect } from 'react';
import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { API_GET, DBRequest, useConfig } from '../../../api/api';
import ExoAvatar from '../../exo/ExoAvatar';
import TypeSkeleton from './TypeSkeleton';
import FormHelperText from '../FormHelperText';
import { useTranslation } from 'react-i18next';

const TypeUsers = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size,
  noPreview,
}) => {
  const { t } = useTranslation();

  const [users, setUsers] = useState({ data: field.options } || {});
  const [isLoading, setIsLoading] = useState(field.options ? false : true);
  const config = useConfig();

  useEffect(() => {
    if (!config || field.options) return;
    DBRequest({
      config,
      path: 'users',
      method: API_GET,
      onResponse: setUsers,
      onLoading: setIsLoading,
    });
  }, [config]);
  function handleChangeSelect(e) {
    const newUserArray = [];
    e.target.value.forEach((value) => {
      const selectedUser = users.data.filter((obj) => obj.id === value)[0];

      newUserArray.push(selectedUser);
    });

    updateValidationOnChange(field.key, newUserArray);
  }

  function getIdArray(data = []) {
    var newArray = [];
    data.forEach((element) => {
      newArray.push(element.id);
    });
    return newArray;
  }

  return (
    <FormControl fullWidth size={size}>
      {isLoading ? (
        <TypeSkeleton size={size} />
      ) : (
        <>
          <InputLabel id="userId-select" shrink={false}>
            {field.label}
          </InputLabel>
          <Select
            multiple
            labelId="userId-select"
            value={getIdArray(dataCollection[field.key])}
            label={field.label}
            onChange={handleChangeSelect}
            displayEmpty
            renderValue={() => null}
            sx={{
              '& .MuiSelect-select': {
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                flexDirection: 'row',
                gap: '8px',
                padding: '0px 32px 0px 14px',
                height: size == 'small' ? '40px!important' : '53px!important',
              },
            }}
          >
            {false && (
              <MenuItem
                value={''}
                className="flex flex-row gap-2 justify-start items-center"
              >
                {t('Unselect')}
              </MenuItem>
            )}
            {users.data.map((element) => (
              <MenuItem
                key={'company-' + element.id}
                value={element.id}
                className="flex flex-row gap-2 justify-start items-center"
              >
                <ExoAvatar
                  picture={element.picture ? element.picture.thumbnailUrl : ''}
                  name={element.firstName + ' ' + element.lastName}
                  size="40px"
                  type={'contact'}
                />
                {element.salutation +
                  ' ' +
                  element.firstName +
                  ' ' +
                  element.lastName}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText />
        </>
      )}
    </FormControl>
  );
};

export default TypeUsers;
